import { Box, Button, Flex, Heading, Input, InputGroup, SimpleGrid, Text } from '@chakra-ui/react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDebouncedFieldRegistry } from '@/utils/filterUtils/useDebouncedFieldRegistry';
import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';
import { Club } from '@/model';
import TeamFilterSelect from '@/components/TeamFilterSelect';
import { StoreMainBannerFilters } from '../../types';

export interface StoreMainBannersFilterBoxProps {
  clubs: Club[];
  filtersForm: UseFormReturn<StoreMainBannerFilters>;
  forceRefetch: () => void;
}

export const StoreMainBannersFilterBox = ({ clubs, filtersForm, forceRefetch }: StoreMainBannersFilterBoxProps) => {
  const { t } = useTranslation();
  const { register, reset } = filtersForm;

  return (
    <Box>
      <Flex align='center' gap='pico' mb='deka'>
        <ChakraFeatherIcon color='text.main' name='filter' />
        <Heading variant='sectionTitle'>
          {t('pages.application_store.components.store_main_banners_filter_box.store_main_banners_filter_box_title')}
        </Heading>
      </Flex>

      <Flex direction={{ base: 'row' }} gap='small' rowGap='micro'>
        <SimpleGrid
          gap='deka'
          alignItems='flex-end'
          columns={{ base: 1, sm: 2, md: 4, lg: 5, xl: 6 }}
          rowGap='xxsmall'
          flexGrow={1}
        >
          {/* Filtro por time */}
          <TeamFilterSelect showFlag name='team_uuid' control={filtersForm.control} clubs={clubs} width='100%' />

          {/* Filtro por título */}
          <InputGroup display='flex' flexDirection='column'>
            <Text fontWeight='medium'>
              {t('pages.application_store.components.store_main_banners_filter_box.store_main_banners_filter_box_title_label')}
            </Text>
            <Input variant='flushed' {...useDebouncedFieldRegistry(() => register('title'))} />
          </InputGroup>
        </SimpleGrid>

        <Button
          alignSelf={{ lg: 'end' }}
          colorScheme='text'
          variant='outline'
          mt='10px'
          onClick={() => {
            reset();
            forceRefetch();
          }}
        >
          {t('pages.application_store.components.store_main_banners_filter_box.store_main_banners_filter_box_clear')}
        </Button>
      </Flex>
    </Box>
  );
};
